import React from "react"
import * as classNames from "./BlockLrSearchResult.module.scss"

import { Swiper, SwiperSlide } from "swiper/react"

// Import Swiper styles
import "swiper/css"
import "swiper/css/pagination"

import { formatDate } from "../../../../../../utils/formatDate"
import { Link } from "gatsby"

import Button from "../../../blocks/button/Button"
import Image from "../../../blocks/image/Image"
import { tagUrl } from "../../../../../../utils/routeLib"
import Icon from "../../../blocks/icon/Icon"

function BlockLrSearchResult({ bigTitle, isAlignLeft, url, article }) {
  const articles = article.Articles || []
  const firstArticle = articles.length > 0 ? [articles[0]] : []

  const imageFormat = (url) => {
    if (!url) return
    const lastSlashIndex = url.lastIndexOf("/")
    const baseUrl = url.substring(0, lastSlashIndex + 1)
    const filename = url.substring(lastSlashIndex + 1)
    const lastDotIndex = filename.lastIndexOf(".")
    let f = filename
    if (lastDotIndex !== -1) {
      f = filename.substring(0, lastDotIndex)
    }

    return {
      L: {
        ext: ".webp",
        url: `${baseUrl}L_${f}.webp`,
        hash: "L_" + f,
        mime: "image/webp",
        name: "L_" + filename,
        path: null,
        size: 13.87,
        width: 770,
        height: 514,
      },
      M: {
        ext: ".webp",
        url: `${baseUrl}M_${f}.webp`,
        hash: "M_" + f,
        mime: "image/webp",
        name: "M_" + filename,
        path: null,
        size: 10.27,
        width: 590,
        height: 394,
      },
      S: {
        ext: ".webp",
        url: `${baseUrl}S_${f}.webp`,
        hash: "S_" + f,
        mime: "image/webp",
        name: "S_" + filename,
        path: null,
        size: 6.27,
        width: 390,
        height: 260,
      },
      XL: {
        ext: ".webp",
        url: `${baseUrl}XL_${f}.webp`,
        hash: "XL_" + f,
        mime: "image/webp",
        name: "XL_" + filename,
        path: null,
        size: 29.87,
        width: 1440,
        height: 960,
      },
      thumbnail: {
        ext: ".jpg",
        url: `${baseUrl}thumbnail_${f}.webp`,
        hash: "thumbnail_" + f,
        mime: "image/webp",
        name: "thumbnail_" + filename,
        path: null,
        size: 5.37,
        width: 234,
        height: 156,
      },
    }
  }
  return (
    <div className={"pb-8"}>
      <h2 className={classNames.title}>{bigTitle}</h2>
      {firstArticle.map((article, index) => (
        <div
          className={`${classNames.ArticleContainer} ${
            isAlignLeft ? classNames.ArticleContainerReverse : ""
          }`}
        >
          <div className={classNames.articleImage}>
            <Link to={article?.route}>
              <Image
                dataSizesPreset={"article"}
                imgSrc={article?.image}
                formats={imageFormat(article.image)}
              />
            </Link>
          </div>
          <div className={classNames.articleContent}>
            <Link to={article?.route}>
              <h2>{article?.title}</h2>
            </Link>
            <Link
              to={article?.route}
              className={classNames.desciptionHover}
            >
              <p>{article?.description}</p>
            </Link>
            <div className={classNames.tagsContainer}>
              <Swiper
                spaceBetween={10}
                slidesPerView={"auto"}
                className={classNames.tagsSwiper}
              >
                <div className={classNames.tags}>
                  {article?.tags?.map((tag, i) => (
                    <SwiperSlide>
                      <Button
                        key={tag}
                        aspect="tag"
                        to={tagUrl(tag.attributes.autoRoute)}
                        color="secondary"
                      >
                        #{tag.attributes.label}
                      </Button>
                    </SwiperSlide>
                  ))}
                </div>
              </Swiper>
              <div className={classNames.iconContainer}>
                <div className={`${classNames.date}`}>
                  <time>{formatDate(article?.date)}</time>
                </div>
                <div className={classNames.icon}>
                  <Icon
                    icon="calendar"
                    color="var(--gris)"
                    width="20px"
                    height="20px"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default BlockLrSearchResult
